import React from 'react'
import { RewardIcon } from '../icons'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

interface RewardButtonProps {
  onClick: () => void
}

const RewardButton: React.FC<RewardButtonProps> = ({
  onClick
}) => {
  return (
    <Container data-testid='rewardButton-container' onClick={onClick}>
      <RewardIcon />
      <FormattedMessage id='DropOffDetails.ActionButton.Redeem' />
    </Container>
  )
}

const Container = styled.button`
  background-color: ${({ theme }) => theme.color.primary};
  color: ${({ theme }) => theme.color.secondary};
  cursor: pointer;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  column-gap: 8px;
  padding: 8px 30px;
  flex: 1;

  font-size: ${({ theme }) => theme.size.small};
  font-family: ${({ theme }) => theme.font.semi};
  font-weight: ${({ theme }) => theme.weight.semi};

  svg {
    path {
      fill: ${({ theme }) => theme.color.secondary};
    }
  }
`

export default RewardButton
